module.exports = __webpack_public_path__ + "static/media/icon.e7f85ffa.png";